(function () {
  var TOKEN_KEY = "faima_follow_session_token_v1";
  var OPEN_KEY = "faima_anonymous_open_task_v3";
  var SKIP_KEY = "faima_follow_skipped_profiles_v1";
  var PENDING_KEY = "faima_pending_task_verifications_v2";
  var ROTATION_KEY = "faima_task_rotation_v2";
  var FAILURE_NOTICE_KEY = "faima_task_failure_notice_v1";
  var GOLDEN_NEXT_CHECK_KEY = "faima_golden_next_check_v1";
  var TIKTOK_ATTRIBUTION_KEY = "faima_tiktok_attribution_v1";
  var AUTO_MISSIONS = ["follow_rush", "like_rush", "task_hunter"];
  var INACTIVITY_TIMEOUT_MS = 20000;
  var REQUEST_TIMEOUT_MS = 12000;
  var PENDING_MAX_AGE_MS = 12 * 60 * 1000;
  var GOLDEN_RETRY_MS = 60 * 1000;
  var GOLDEN_COOLDOWN_MS = 60 * 1000;
  var RETRYABLE_RESERVATION_CODES = ["task_already_completed", "task_unavailable", "task_reservation_expired", "task_attempt_expired", "task_metric_stale", "task_metric_unavailable", "task_target_private", "preverified_baseline_unavailable"];
  var PACKAGE_GOALS = [
    { quantity: 250, cost: 250 },
    { quantity: 500, cost: 500 },
    { quantity: 1000, cost: 1000 },
    { quantity: 2500, cost: 2500 },
    { quantity: 5000, cost: 5000 },
    { quantity: 10000, cost: 10000 }
  ];

  function initialize(root) {
    if (!root || root.dataset.feReady === "true") return;
    root.dataset.feReady = "true";
    var copyNode = root.querySelector("[data-fe-copy]");
    var copy = JSON.parse(copyNode ? copyNode.textContent : "{}");
    var apiUrl = root.dataset.apiUrl || "https://panel.faimainstant.ro/api/faima/follow-credits";
    var avatarApiUrl = root.dataset.avatarUrl || "https://panel.faimainstant.ro/api/faima/instagram-avatar";
    var profileApiUrl = root.dataset.profileUrl || "https://panel.faimainstant.ro/api/faima/instagram-profile";
    var taskMarket = String(root.dataset.market || "ro").toLowerCase() === "es" ? "es" : "ro";
    var paidBoostVariantId = String(root.dataset.paidBoostVariantId || "").trim();
    var profileHydration = {};
    var state = {
      token: readSessionToken(),
      task: null,
      tasks: { follow: [], like: [] },
      balance: 0,
      reward: 1,
      missions: [],
      boost: null,
      referralCode: "",
      interaction: null,
      pending: readPending(),
      reservationTimer: null,
      pendingTimers: {},
      unavailableTaskKeys: new Set(),
      goldenNextCheckAt: Math.max(0, Number(readStorage(GOLDEN_NEXT_CHECK_KEY) || 0)),
      stockExhausted: false,
      loadingState: null,
      reserving: false,
      busy: false,
      paused: false
    };

    function readStorage(key) {
      try { return localStorage.getItem(key) || ""; } catch { return ""; }
    }

    function writeStorage(key, value) {
      try {
        if (value) localStorage.setItem(key, value);
        else localStorage.removeItem(key);
      } catch {}
    }

    function cookieValue(name) {
      try {
        var prefix = String(name || "") + "=";
        var cookies = String(document.cookie || "").split(";");
        for (var index = 0; index < cookies.length; index += 1) {
          var item = cookies[index].trim();
          if (item.indexOf(prefix) === 0) return decodeURIComponent(item.slice(prefix.length));
        }
      } catch {}
      return "";
    }

    function marketingConsentState() {
      try {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (privacy && typeof privacy.marketingAllowed === "function") return privacy.marketingAllowed() === true;
      } catch {}
      return null;
    }

    function newTikTokEventId() {
      try {
        if (window.crypto && typeof window.crypto.randomUUID === "function") return "faima_" + window.crypto.randomUUID();
      } catch {}
      return "faima_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 14);
    }

    function readTikTokAttribution(eventId) {
      var stored = {};
      try { stored = JSON.parse(readStorage(TIKTOK_ATTRIBUTION_KEY) || "{}"); } catch {}
      try {
        var ttclid = new URLSearchParams(window.location.search).get("ttclid") || "";
        if (/^[A-Za-z0-9._~%-]{8,512}$/.test(ttclid)) stored.ttclid = ttclid;
      } catch {}
      var ttp = cookieValue("_ttp") || String(stored.ttp || "");
      if (/^[A-Za-z0-9._~%-]{8,512}$/.test(ttp)) stored.ttp = ttp;
      writeStorage(TIKTOK_ATTRIBUTION_KEY, JSON.stringify(stored));
      return {
        eventId: eventId,
        ttclid: String(stored.ttclid || ""),
        ttp: String(stored.ttp || ""),
        pageUrl: window.location.origin + window.location.pathname,
        referrer: String(document.referrer || "").slice(0, 1500),
        consentGranted: marketingConsentState() === true
      };
    }

    function trackTikTokTaskButton(task, eventId) {
      if (!task || marketingConsentState() === false) return;
      try {
        if (!window.ttq || typeof window.ttq.track !== "function") return;
        window.ttq.track("ViewContent", {
          content_type: "product",
          content_name: task.type === "follow" ? "instagram_follow_task" : "instagram_like_task",
          description: "faima_free_task_action"
        }, { event_id: eventId });
      } catch {}
    }

    function validSessionToken(value) {
      var token = String(value || "").trim();
      return /^[A-Za-z0-9_-]{43}$/.test(token) ? token : "";
    }

    function readSessionTokenCandidates() {
      var candidates = [];
      function add(value) {
        var token = validSessionToken(value);
        if (token && candidates.indexOf(token) === -1) candidates.push(token);
      }
      add(readStorage(TOKEN_KEY));
      add(readStorage("faima_follow_session_v1"));
      try {
        var prefix = TOKEN_KEY + "=";
        var parts = String(document.cookie || "").split(";");
        for (var index = 0; index < parts.length; index += 1) {
          var part = parts[index].trim();
          if (part.indexOf(prefix) !== 0) continue;
          add(decodeURIComponent(part.slice(prefix.length)));
        }
      } catch {}
      return candidates.slice(0, 3);
    }

    function readSessionToken() {
      return readSessionTokenCandidates()[0] || "";
    }

    function writeSessionToken(value) {
      var token = validSessionToken(value);
      writeStorage(TOKEN_KEY, token);
      try {
        document.cookie = TOKEN_KEY + "=" + encodeURIComponent(token) + "; Path=/; Max-Age=" + (token ? "31536000" : "0") + "; SameSite=Lax; Secure";
      } catch {}
    }

    function readSkipped() {
      try {
        var parsed = JSON.parse(readStorage(SKIP_KEY) || "[]");
        return Array.isArray(parsed) ? parsed.filter(function (value) { return typeof value === "string"; }).slice(-50) : [];
      } catch {
        return [];
      }
    }

    function readPending() {
      try {
        var parsed = JSON.parse(readStorage(PENDING_KEY) || "[]");
        return Array.isArray(parsed) ? parsed.filter(function (item) {
          return item && typeof item === "object" && item.attemptId && item.targetId && item.taskType;
        }).slice(-8) : [];
      } catch {
        return [];
      }
    }

    function savePending() {
      writeStorage(PENDING_KEY, state.pending.length ? JSON.stringify(state.pending.slice(-8)) : "");
    }

    function readOpenAttempt() {
      try {
        var parsed = JSON.parse(readStorage(OPEN_KEY) || "null");
        if (!parsed || typeof parsed !== "object" || !parsed.attemptId || !parsed.targetId) return null;
        if (Number(parsed.expiresAt || 0) <= Date.now()) {
          writeStorage(OPEN_KEY, "");
          return null;
        }
        return parsed;
      } catch {
        return null;
      }
    }

    function format(value) {
      return Number(value || 0).toLocaleString(copy.locale || "ro-RO");
    }

    function baseRewardForType(taskType) {
      return 1;
    }

    function renderPackageProgress() {
      var balance = Math.max(0, Math.floor(Number(state.balance || 0)));
      var goal = PACKAGE_GOALS.find(function (item) { return balance < item.cost; }) || PACKAGE_GOALS[PACKAGE_GOALS.length - 1];
      var percentage = goal.cost > 0 ? Math.min(100, Math.round(balance / goal.cost * 100)) : 100;
      var remaining = Math.max(0, goal.cost - balance);
      var milestone = percentage >= 100 ? copy.progressBadge100
        : percentage >= 50 ? copy.progressBadge50
        : percentage >= 25 ? copy.progressBadge25
        : percentage >= 10 ? copy.progressBadge10
        : copy.progressBadgeStart;
      var card = root.querySelector(".fe-package-progress");
      var count = root.querySelector("[data-fe-package-progress-count]");
      var percent = root.querySelector("[data-fe-package-progress-percent]");
      var target = root.querySelector("[data-fe-package-progress-target]");
      var badge = root.querySelector("[data-fe-package-progress-badge]");
      var remainingNode = root.querySelector("[data-fe-package-progress-remaining]");
      var bar = root.querySelector("[data-fe-package-progress-bar]");
      var fill = root.querySelector("[data-fe-package-progress-fill]");
      if (count) count.textContent = format(balance) + "/" + format(goal.cost);
      if (percent) percent.textContent = percentage + "%";
      if (target) target.textContent = format(goal.quantity);
      if (badge) badge.textContent = milestone;
      if (remainingNode) {
        remainingNode.textContent = remaining > 0
          ? copy.progressRemaining + " " + format(remaining) + " 🚀 " + copy.progressRemainingSuffix
          : copy.progressUnlocked;
      }
      if (fill) fill.style.width = percentage + "%";
      if (card) {
        card.classList.toggle("is-moving", percentage >= 10 && percentage < 50);
        card.classList.toggle("is-close", percentage >= 50 && percentage < 100);
        card.classList.toggle("is-unlocked", percentage >= 100);
      }
      if (bar) {
        bar.setAttribute("aria-valuenow", String(percentage));
        bar.setAttribute("aria-valuetext", percentage + "% " + copy.progressToPackage + " " + format(goal.quantity));
      }
    }

    function setMessage(message, kind) {
      var node = root.querySelector("[data-fe-task-message]");
      if (!node) return;
      node.textContent = message || "";
      node.classList.toggle("is-error", kind === "error");
      node.classList.toggle("is-success", kind === "success");
    }

    function setBusy(value) {
      state.busy = value;
      root.querySelectorAll("button").forEach(function (button) {
        if (!button.hasAttribute("data-fe-static-disabled")) button.disabled = value;
      });
    }

    function fetchWithTimeout(url, options, timeoutMs) {
      var controller = typeof AbortController === "function" ? new AbortController() : null;
      var requestOptions = Object.assign({}, options || {});
      var timer = null;
      if (controller) {
        requestOptions.signal = controller.signal;
        timer = window.setTimeout(function () {
          controller.abort();
        }, Math.max(1000, Number(timeoutMs || REQUEST_TIMEOUT_MS)));
      }
      return fetch(url, requestOptions).catch(function (error) {
        if (error && error.name === "AbortError") {
          var timeoutError = new Error(copy.timeoutError || copy.genericError);
          timeoutError.status = 0;
          throw timeoutError;
        }
        throw error;
      }).finally(function () {
        if (timer) window.clearTimeout(timer);
      });
    }

    function request(action, payload, options) {
      var requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(Object.assign({
          action: action,
          token: state.token,
          market: taskMarket,
          language: String(copy.locale || "ro").toLowerCase().indexOf("es") === 0
            ? "es"
            : String(copy.locale || "ro").toLowerCase().indexOf("en") === 0 ? "en" : "ro"
        }, payload || {}))
      };
      if (options && options.keepalive === true) requestOptions.keepalive = true;
      return fetchWithTimeout(apiUrl, requestOptions).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) {
            var error = new Error(body.error || copy.genericError);
            error.status = response.status;
            error.code = String(body.code || "");
            throw error;
          }
          return body;
        });
      });
    }

    function saveSession(body) {
      if (body && body.token) {
        state.token = String(body.token);
        writeSessionToken(state.token);
      }
      if (body && body.credits != null) state.balance = Number(body.credits || 0);
      if (body && body.reward != null) state.reward = Number(body.reward || 1);
    }

    function saveMissionState(body) {
      if (!body || typeof body !== "object") return;
      if (Array.isArray(body.missions)) state.missions = body.missions;
      if (Object.prototype.hasOwnProperty.call(body, "boost")) state.boost = body.boost || null;
      if (body.referralCode) state.referralCode = String(body.referralCode);
    }

    function scheduleGoldenCheck(nextAvailableAt, fallbackMs) {
      var parsed = new Date(String(nextAvailableAt || "")).getTime();
      state.goldenNextCheckAt = Number.isFinite(parsed) && parsed > Date.now()
        ? parsed
        : Date.now() + Math.max(10000, Number(fallbackMs || GOLDEN_RETRY_MS));
      writeStorage(GOLDEN_NEXT_CHECK_KEY, String(state.goldenNextCheckAt));
    }

    function missionByCode(code) {
      return state.missions.find(function (mission) { return mission && mission.code === code; }) || null;
    }

    function secondsUntil(value) {
      var target = new Date(String(value || "")).getTime();
      return Number.isFinite(target) ? Math.max(0, Math.ceil((target - Date.now()) / 1000)) : 0;
    }

    function formatDuration(seconds) {
      var remaining = Math.max(0, Number(seconds || 0));
      var minutes = Math.floor(remaining / 60);
      var rest = remaining % 60;
      return String(minutes).padStart(2, "0") + ":" + String(rest).padStart(2, "0");
    }

    function activeMultiplier() {
      return state.boost && secondsUntil(state.boost.expiresAt) > 0 ? Number(state.boost.multiplier || 1) : 1;
    }

    function effectiveReward(task) {
      var base = Number(task && (task.baseReward || task.reward) || 0);
      return Math.floor(base * activeMultiplier());
    }

    function profileFollowers(profile) {
      var hasFollowers = profile && profile.followersCount != null;
      var followers = Number(hasFollowers ? profile.followersCount : NaN);
      return hasFollowers && Number.isSafeInteger(followers) && followers >= 0
        ? format(followers) + " " + copy.followersLabel
        : "";
    }

    function setOptionalText(selector, value) {
      var node = root.querySelector(selector);
      if (!node) return;
      node.textContent = value || "";
      node.hidden = !value;
    }

    function setProfileAvatar(container, username) {
      if (!container) return;
      var image = container.querySelector("[data-fe-avatar-image]");
      var fallback = container.querySelector("[data-fe-avatar-fallback]");
      var safeUsername = String(username || "").replace(/^@+/, "");
      var resolved = avatarApiUrl + "?username=" + encodeURIComponent(safeUsername);
      if (image.dataset.feSrc === resolved && image.getAttribute("src")) return;
      image.dataset.feSrc = resolved;
      fallback.textContent = safeUsername ? safeUsername.charAt(0).toUpperCase() : "◎";
      fallback.hidden = false;
      image.hidden = true;
      image.removeAttribute("src");
      image.alt = safeUsername ? "Poza de profil @" + safeUsername : "Profil Instagram";
      image.onload = function () { image.hidden = false; fallback.hidden = true; };
      image.onerror = function () { image.hidden = true; fallback.hidden = false; image.removeAttribute("src"); };
      image.src = String(resolved);
    }

    function hydrateProfile(username, taskId) {
      var safeUsername = String(username || "").replace(/^@+/, "").toLowerCase();
      if (!safeUsername || profileHydration[safeUsername]) return;
      profileHydration[safeUsername] = true;
      fetchWithTimeout(profileApiUrl + "?username=" + encodeURIComponent(safeUsername), {
        method: "GET",
        headers: { "Accept": "application/json" },
        credentials: "omit"
      }, 8000).then(function (response) {
        if (!response.ok) throw new Error("profile_unavailable");
        return response.json();
      }).then(function (body) {
        var profile = body && body.profile;
        if (!profile || !state.task || String(state.task.id) !== String(taskId)) return;
        state.task.displayName = profile.displayName || state.task.displayName;
        state.task.biography = profile.biography || "";
        state.task.followersCount = profile.followersCount != null ? Number(profile.followersCount) : null;
        renderTask();
      }).catch(function () {});
    }

    function instagramEmbedUrl(value) {
      try {
        var url = new URL(String(value || ""));
        if (url.protocol !== "https:" || url.hostname !== "www.instagram.com") return "";
        var match = url.pathname.match(/^\/(p|reel|tv)\/([A-Za-z0-9_-]+)\/?$/);
        return match ? "https://www.instagram.com/" + match[1] + "/" + match[2] + "/embed/captioned/" : "";
      } catch {
        return "";
      }
    }

    function instagramUniversalUrl(value) {
      try {
        var url = new URL(String(value || ""));
        var hostname = String(url.hostname || "").toLowerCase();
        if (url.protocol !== "https:" || ["instagram.com", "www.instagram.com", "m.instagram.com"].indexOf(hostname) === -1) return "";
        url.hostname = "www.instagram.com";
        url.hash = "";
        return url.toString();
      } catch {
        return "";
      }
    }

    function instagramShortcodeMediaId(shortcode) {
      if (typeof BigInt !== "function" || !/^[A-Za-z0-9_-]+$/.test(String(shortcode || ""))) return "";
      var alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
      var mediaId = BigInt(0);
      for (var index = 0; index < shortcode.length; index += 1) {
        var value = alphabet.indexOf(shortcode.charAt(index));
        if (value < 0) return "";
        mediaId = mediaId * BigInt(64) + BigInt(value);
      }
      return mediaId.toString();
    }

    function instagramAppUrl(value) {
      try {
        var url = new URL(String(value || ""));
        if (url.protocol !== "https:" || url.hostname !== "www.instagram.com") return "";
        var post = url.pathname.match(/^\/(p|reel|tv)\/([A-Za-z0-9_-]+)\/?$/);
        if (post) {
          var mediaId = instagramShortcodeMediaId(post[2]);
          return mediaId ? "instagram://media?id=" + encodeURIComponent(mediaId) : "";
        }
        var profile = url.pathname.match(/^\/([A-Za-z0-9._]+)\/?$/);
        return profile ? "instagram://user?username=" + encodeURIComponent(profile[1]) : "";
      } catch {
        return "";
      }
    }

    function instagramLaunchUrl(value) {
      var canonical = instagramUniversalUrl(value);
      if (!canonical) return "";
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent || "")) return instagramAppUrl(canonical);
      if (!/Android/i.test(navigator.userAgent || "")) return canonical;
      try {
        var url = new URL(canonical);
        return "intent://www.instagram.com" + url.pathname + url.search +
          "#Intent;scheme=https;package=com.instagram.android;S.browser_fallback_url=" +
          encodeURIComponent(canonical) + ";end";
      } catch {
        return canonical;
      }
    }

    function taskKey(task) {
      return task ? String(task.type || "follow") + ":" + String(task.id || "") : "";
    }

    function readTaskRotation() {
      try {
        var parsed = JSON.parse(readStorage(ROTATION_KEY) || "null");
        if (!parsed || (parsed.group !== "follow" && parsed.group !== "post")) return { group: "", streak: 0 };
        return { group: parsed.group, streak: Math.max(0, Number(parsed.streak || 0)) };
      } catch {
        return { group: "", streak: 0 };
      }
    }

    function preferredTaskGroup() {
      var rotation = readTaskRotation();
      if (!rotation.group) return "follow";
      if (rotation.streak >= 2) return rotation.group === "follow" ? "post" : "follow";
      return rotation.group;
    }

    function recordTaskRotation(task) {
      var group = task && task.type === "follow" ? "follow" : "post";
      var rotation = readTaskRotation();
      writeStorage(ROTATION_KEY, JSON.stringify({
        group: group,
        streak: rotation.group === group ? rotation.streak + 1 : 1
      }));
    }

    function combinedTasks(excludeKey, includePreviouslySkipped) {
      var skipped = new Set(readSkipped());
      var pending = new Set(state.pending.map(function (item) { return String(item.taskType) + ":" + String(item.targetId); }));
      function available(type) {
        return (state.tasks[type] || []).map(function (task) {
          return Object.assign({}, task, { type: type });
        }).filter(function (task) {
          var key = taskKey(task);
          return key !== excludeKey
            && (includePreviouslySkipped === true || !skipped.has(key))
            && !pending.has(key)
            && !state.unavailableTaskKeys.has(key);
        });
      }
      function priorityTier(task) {
        var tier = Number(task && task.priorityTier);
        return Number.isFinite(tier) && tier >= 0 && tier <= 5 ? tier : 3;
      }
      function priorityNumber(task, field) {
        var value = Number(task && task[field]);
        return Number.isFinite(value) ? value : 0;
      }
      var followTasks = available("follow");
      var postLists = [available("like")];
      var postTasks = [];
      var max = Math.max.apply(Math, postLists.map(function (list) { return list.length; }).concat([0]));
      for (var index = 0; index < max; index += 1) {
        postLists.forEach(function (list) {
          var task = list[index];
          if (task) postTasks.push(task);
        });
      }
      var preferredGroup = preferredTaskGroup();
      return followTasks.concat(postTasks).sort(function (left, right) {
        var tierOrder = priorityTier(left) - priorityTier(right);
        if (tierOrder) return tierOrder;
        var fallbackOrder = Number(left && left.fallback === true) - Number(right && right.fallback === true);
        if (fallbackOrder) return fallbackOrder;
        var smallestOrder = priorityNumber(left, "priorityQuantity") - priorityNumber(right, "priorityQuantity");
        if (smallestOrder) return smallestOrder;
        var leftGroup = left && left.type === "follow" ? "follow" : "post";
        var rightGroup = right && right.type === "follow" ? "follow" : "post";
        if (leftGroup !== rightGroup) return leftGroup === preferredGroup ? -1 : 1;
        return priorityNumber(right, "priorityNewestOrderAt") - priorityNumber(left, "priorityNewestOrderAt")
          || priorityNumber(left, "remaining") - priorityNumber(right, "remaining")
          || priorityNumber(right, "priorityOrderAt") - priorityNumber(left, "priorityOrderAt")
          || priorityNumber(right, "baseReward") - priorityNumber(left, "baseReward");
      });
    }

    function clearReservationTimer() {
      if (state.reservationTimer) window.clearTimeout(state.reservationTimer);
      state.reservationTimer = null;
    }

    function scheduleReservationExpiry() {
      clearReservationTimer();
      if (!state.task || state.task.status !== "assigned" || !state.interaction || state.interaction.status !== "assigned") return;
      var delay = Math.max(0, Number(state.interaction.expiresAt || 0) - Date.now());
      state.reservationTimer = window.setTimeout(function () {
        var expiredKey = taskKey(state.task);
        releaseCurrentTask("reservation_timeout", false).finally(function () {
          loadState({ preserveMessage: true, excludeKey: expiredKey });
        });
      }, delay + 60);
    }

    function applyReservation(task, interaction) {
      clearEmptyTaskState();
      interaction.taskSnapshot = Object.assign({}, task, {
        type: String(task.type || interaction.taskType || "follow")
      });
      state.interaction = interaction;
      state.task = Object.assign({}, task, {
        status: String(interaction.status || "assigned"),
        baseReward: Number(task.baseReward || baseRewardForType(task.type)),
        reward: Number(interaction.reward || task.reward || baseRewardForType(task.type)),
        missionCode: String(interaction.missionCode || task.missionCode || "")
      });
      writeStorage(OPEN_KEY, JSON.stringify(interaction));
      scheduleReservationExpiry();
      renderTask();
    }

    function restoreServerTask(active) {
      if (!active || !active.attemptId || !active.task || typeof active.task !== "object") return false;
      var task = Object.assign({}, active.task, {
        id: String(active.targetId || active.task.id || ""),
        type: String(active.taskType || active.task.type || "follow")
      });
      if (!task.id || ["follow", "like"].indexOf(task.type) === -1) return false;
      var stored = readOpenAttempt();
      var sameAttempt = stored && String(stored.attemptId) === String(active.attemptId);
      var status = String(active.status || "assigned") === "opened" ? "opened" : "assigned";
      var interaction = sameAttempt ? stored : {};
      interaction.attemptId = String(active.attemptId);
      interaction.targetId = task.id;
      interaction.taskType = task.type;
      interaction.status = status;
      interaction.openedAt = new Date(String(active.openedAt || "")).getTime() || Number(interaction.openedAt || 0);
      interaction.expiresAt = new Date(String(active.expiresAt || "")).getTime()
        || Number(interaction.expiresAt || 0)
        || Date.now() + (status === "opened" ? 15 * 60 * 1000 : INACTIVITY_TIMEOUT_MS);
      interaction.reward = Number(active.reward || task.reward || task.baseReward || baseRewardForType(task.type));
      interaction.golden = active.golden === true || task.golden === true;
      interaction.goldenLabel = String(active.goldenLabel || task.goldenLabel || "");
      interaction.missionCode = interaction.golden ? "gold_follow" : String(task.missionCode || "");
      interaction.baselineReady = true;
      if (status === "opened") {
        interaction.launchAttempted = true;
        interaction.pageHidden = true;
        interaction.focusReturned = true;
      }
      applyReservation(task, interaction);
      return true;
    }

    function clearEmptyTaskState() {
      state.stockExhausted = false;
    }

    function showEmptyTaskState() {
      if (state.paused || state.task) return;
      state.stockExhausted = true;
      setMessage(copy.noTasks || "Nu mai sunt task-uri de făcut pentru moment. Te rugăm să revii mai târziu.", "");
      renderTask();
    }

    function updateFollowTaskProfile(body) {
      if (!body || !body.profile || !state.task || state.task.type !== "follow") return;
      state.task.displayName = body.profile.displayName || state.task.displayName;
      state.task.biography = body.profile.biography || "";
      state.task.followersCount = body.profile.followersCount != null ? Number(body.profile.followersCount) : null;
    }

    function markFollowBaselineReady(body, interaction) {
      saveSession(body);
      if (!state.interaction || String(state.interaction.attemptId) !== String(interaction.attemptId)) return;
      updateFollowTaskProfile(body);
      interaction.status = "assigned";
      interaction.baselineReady = true;
      interaction.serverExpiresAt = new Date(String(body.expiresAt || "")).getTime() || Date.now() + 15 * 60 * 1000;
      interaction.expiresAt = Date.now() + INACTIVITY_TIMEOUT_MS;
      interaction.taskSnapshot = Object.assign({}, state.task || interaction.taskSnapshot || {});
      delete interaction.pendingLaunchUrl;
      delete interaction.baselineVerificationJob;
      delete interaction.retryAfterMs;
      state.interaction = interaction;
      if (state.task) state.task.status = "assigned";
      writeStorage(OPEN_KEY, JSON.stringify(interaction));
      setMessage("", "");
      scheduleReservationExpiry();
      renderTask();
    }

    function discardPreparedTask(interaction, error) {
      if (!state.interaction || String(state.interaction.attemptId) !== String(interaction.attemptId)) return;
      var key = taskKey(state.task);
      clearReservationTimer();
      state.task = null;
      state.interaction = null;
      writeStorage(OPEN_KEY, "");
      setMessage(error && error.message ? error.message : copy.genericError, "error");
      renderTask();
      request("release", { attemptId: interaction.attemptId, reason: "baseline_unavailable" }).catch(function () {}).finally(function () {
        window.setTimeout(function () { loadState({ preserveMessage: true, excludeKey: key }); }, 0);
      });
    }

    function prepareFollowBaseline(task, interaction, alreadyApplied) {
      interaction.status = "preparing";
      interaction.baselineMode = "prefetch";
      if (alreadyApplied) {
        state.interaction = interaction;
        if (state.task) state.task.status = "preparing";
        writeStorage(OPEN_KEY, JSON.stringify(interaction));
        clearReservationTimer();
        renderTask();
      } else {
        applyReservation(task, interaction);
      }
      return request("open", {
        taskType: interaction.taskType,
        targetId: interaction.targetId,
        attemptId: interaction.attemptId
      }).then(function (body) {
        saveSession(body);
        if (!state.interaction || String(state.interaction.attemptId) !== String(interaction.attemptId)) return;
        if (body.verificationPending) {
          state.interaction.baselineVerificationJob = String(body.verificationJob || "");
          state.interaction.retryAfterMs = Number(body.retryAfterMs || 3000);
          writeStorage(OPEN_KEY, JSON.stringify(state.interaction));
          pollOpenBaseline(state.interaction);
          return;
        }
        markFollowBaselineReady(body, state.interaction);
      }).catch(function (error) {
        discardPreparedTask(interaction, error);
      });
    }

    function reserveNextTask(excludeKey, suppressEmptyState) {
      if (state.paused) return Promise.resolve();
      if (state.reserving) return Promise.resolve();
      var stored = readOpenAttempt();
      var allTasks = ["follow", "like"].reduce(function (list, type) {
        return list.concat((state.tasks[type] || []).map(function (task) { return Object.assign({}, task, { type: type }); }));
      }, []);
      if (stored && stored.status !== "pending") {
        var restoredTask = allTasks.find(function (task) {
          return taskKey(task) === String(stored.taskType) + ":" + String(stored.targetId);
        });
        if (!restoredTask && stored.taskSnapshot && typeof stored.taskSnapshot === "object") {
          var snapshot = Object.assign({}, stored.taskSnapshot, { type: String(stored.taskType || stored.taskSnapshot.type || "follow") });
          if (taskKey(snapshot) === String(stored.taskType) + ":" + String(stored.targetId)) restoredTask = snapshot;
        }
        if (restoredTask) {
          applyReservation(restoredTask, stored);
          if (stored.baselineVerificationJob) pollOpenBaseline(stored);
          return Promise.resolve();
        }
        writeStorage(OPEN_KEY, "");
      }

      var candidates = combinedTasks(String(excludeKey || ""), false);
      // A skipped task remains available to other visitors immediately. If
      // this visitor has exhausted every fresh candidate in the current
      // server-prepared stock, recycle older skips instead of entering a
      // state-refresh loop. The task just left is still excluded.
      if (!candidates.length) candidates = combinedTasks(String(excludeKey || ""), true);
      state.reserving = true;
      function previewCandidate(task) {
        clearEmptyTaskState();
        state.interaction = null;
        state.task = Object.assign({}, task, {
          status: "assigned",
          baseReward: Number(task.baseReward || baseRewardForType(task.type)),
          reward: Number(task.reward || task.baseReward || baseRewardForType(task.type))
        });
        writeStorage(OPEN_KEY, "");
        scheduleReservationExpiry();
        renderTask();
        return Promise.resolve();
      }
      function tryCandidate(index) {
        if (index >= candidates.length) return Promise.resolve();
        return previewCandidate(candidates[index]);
      }
      function tryGoldenThenCandidates() {
        if (state.goldenNextCheckAt > Date.now()) return tryCandidate(0);
        return request("reserve_golden", {}).then(function (body) {
          saveSession(body);
          saveMissionState(body);
          if (!body.available || !body.task || !body.attemptId) {
            scheduleGoldenCheck(body.nextAvailableAt, GOLDEN_RETRY_MS);
            return tryCandidate(0);
          }
          scheduleGoldenCheck(null, GOLDEN_COOLDOWN_MS);
          var task = Object.assign({}, body.task, {
            type: String(body.task.type || body.taskType || "follow"),
            golden: true,
            goldenLabel: String(body.goldenLabel || "")
          });
          var interaction = {
            attemptId: String(body.attemptId),
            targetId: String(task.id),
            taskType: String(task.type),
            status: "assigned",
            openedAt: 0,
            expiresAt: new Date(String(body.expiresAt || "")).getTime() || Date.now() + INACTIVITY_TIMEOUT_MS,
            reward: Number(body.reward || task.reward || 2),
            missionCode: "gold_follow",
            golden: true,
            baselineReady: body.baselineReady === true,
            pageHidden: false,
            sawBlur: false,
            focusReturned: false
          };
          if (body.baselineReady !== true) {
            return request("release", { attemptId: interaction.attemptId, reason: "baseline_unavailable" })
              .catch(function () {})
              .then(function () { return tryCandidate(0); });
          }
          recordTaskRotation(task);
          applyReservation(task, interaction);
        }, function (error) {
          if (!error || !error.status || error.status === 404 || error.status >= 500
            || error.code === "gold_profile_unavailable" || RETRYABLE_RESERVATION_CODES.indexOf(String(error.code || "")) >= 0) {
            scheduleGoldenCheck(null, GOLDEN_RETRY_MS);
            return tryCandidate(0);
          }
          throw error;
        });
      }
      var officialIndex = candidates.findIndex(function (task) {
        return task && (task.official === true || String(task.username || "").replace(/^@+/, "").toLowerCase() === "faimainstant.ro");
      });
      var officialTask = officialIndex >= 0 ? candidates.splice(officialIndex, 1)[0] : null;
      var reservation = officialTask
        ? previewCandidate(officialTask)
        : tryGoldenThenCandidates();
      return reservation.catch(function (error) {
        state.task = null;
        state.interaction = null;
        setMessage(error.message || copy.genericError, "error");
        renderTask();
      }).finally(function () {
        state.reserving = false;
        if (!state.task && !state.paused && suppressEmptyState !== true) showEmptyTaskState();
      });
    }

    function buttonState() {
      if (!state.task) return { label: "", action: "" };
      if (state.task.status === "preparing") return { label: copy.opening, action: "" };
      if (state.task.status === "assigned") return {
        label: state.task.type === "follow" ? copy.openFollow : copy.openLike,
        action: "open"
      };
      if (state.task.status === "opened") return { label: copy.done, action: "complete" };
      return { label: "", action: "" };
    }

    function setMissionMessage(message, kind) {
      var node = root.querySelector("[data-fe-mission-message]");
      if (!node) return;
      node.textContent = message || "";
      node.classList.toggle("is-error", kind === "error");
      node.classList.toggle("is-success", kind === "success");
    }

    function renderMissions() {
      root.querySelectorAll("[data-fe-mission]").forEach(function (card) {
        var code = String(card.dataset.feMission || "");
        var mission = missionByCode(code);
        if (code === "double_rockets") {
          card.hidden = !mission;
          if (!mission) return;
        }
        var status = mission ? String(mission.status || "available") : "available";
        if (AUTO_MISSIONS.indexOf(code) >= 0 && status === "available") status = "active";
        if (status === "cooldown" && secondsUntil(mission && mission.nextAvailableAt) < 1) {
          status = "available";
          mission.status = "available";
        }
        var progress = mission ? Number(mission.progress || 0) : 0;
        var target = mission ? Math.max(1, Number(mission.target || 1)) : 1;
        var percentage = Math.min(100, Math.round(progress / target * 100));
        var progressBar = card.querySelector("[data-fe-mission-progress]");
        var count = card.querySelector("[data-fe-mission-count]");
        var button = card.querySelector("[data-fe-mission-button]");
        var cooldown = card.querySelector("[data-fe-mission-cooldown]");
        var rewardLabel = card.querySelector(".fe-mission-reward");
        if (rewardLabel && mission && code !== "double_rockets") {
          rewardLabel.textContent = "🚀 +" + format(Math.max(0, Number(mission.reward || 0)));
        }

        card.classList.toggle("is-active", status === "active");
        card.classList.toggle("is-complete", status === "completed");
        card.classList.toggle("is-locked", status === "cooldown");
        if (progressBar) progressBar.style.width = percentage + "%";
        if (count) count.textContent = code === "double_rockets" ? "" : progress + "/" + target;
        if (!button || !cooldown) return;

        var wait = secondsUntil(mission && mission.nextAvailableAt);
        cooldown.hidden = status !== "cooldown" || wait < 1;
        cooldown.textContent = cooldown.hidden ? "" : copy.missionReturns + " " + formatDuration(wait);
        button.disabled = state.busy;
        if (status === "completed") {
          button.textContent = copy.missionComplete;
          button.disabled = true;
        } else if (status === "cooldown") {
          button.textContent = copy.missionComplete;
          button.disabled = true;
        } else if (status === "active") {
          if (code === "gold_follow") {
            button.textContent = copy.missionContinue;
          } else if (code === "invite_five") {
            button.textContent = copy.missionInvite;
          } else if (code === "double_rockets") {
            button.textContent = copy.boostActive;
            button.disabled = true;
          } else {
            button.textContent = copy.missionProgress + (target > 1 ? " " + progress + "/" + target : "");
            button.disabled = true;
          }
        } else {
          button.textContent = code === "invite_five" ? copy.missionInvite : code === "double_rockets" ? copy.missionActivate : copy.missionStart;
        }
      });

      var boost = root.querySelector("[data-fe-boost]");
      var boostSeconds = state.boost ? secondsUntil(state.boost.expiresAt) : 0;
      boost.hidden = boostSeconds < 1;
      boost.textContent = boostSeconds > 0 ? copy.boostActive + " · " + formatDuration(boostSeconds) : "";
      var boostUpsell = root.querySelector("[data-fe-boost-upsell]");
      var doubleMission = missionByCode("double_rockets");
      if (boostUpsell) {
        boostUpsell.hidden = boostSeconds > 0 || !doubleMission || String(doubleMission.status || "available") === "available";
      }
    }

    function renderTask() {
      root.querySelector("[data-fe-balance]").textContent = format(state.balance);
      renderPackageProgress();
      var loading = root.querySelector("[data-fe-loading]");
      var taskNode = root.querySelector("[data-fe-task]");
      var isPreparing = Boolean(state.task && state.task.status === "preparing");
      loading.hidden = Boolean(state.task) && !isPreparing || state.paused || state.stockExhausted;
      taskNode.hidden = !state.task || isPreparing;
      renderMissions();
      if (!state.task || isPreparing) return;

      var isGolden = state.task.golden === true || state.interaction && state.interaction.golden === true;
      taskNode.classList.toggle("is-golden", isGolden);
      var username = String(state.task.username || "").replace(/^@+/, "");
      var isOfficial = state.task.official === true || username.toLowerCase() === "faimainstant.ro";
      taskNode.classList.toggle("is-official", isOfficial);
      var officialBadge = root.querySelector("[data-fe-official-badge]");
      if (officialBadge) officialBadge.hidden = !isOfficial;
      var goldenBadge = root.querySelector("[data-fe-golden-badge]");
      goldenBadge.hidden = !isGolden;
      goldenBadge.textContent = isGolden
        ? "✨ " + (state.task.type === "like" ? copy.goldenLike : copy.goldenFollow)
        : "";

      var isFollow = state.task.type === "follow";
      var profileCard = root.querySelector(".fe-profile-card");
      profileCard.hidden = !isFollow;
      root.querySelector("[data-fe-task-title]").textContent = "@" + username;
      setOptionalText("[data-fe-task-kind]", isFollow ? copy.profileType : "");
      setOptionalText("[data-fe-task-display]", isFollow && state.task.displayName && state.task.displayName !== "@" + username ? state.task.displayName : "");
      setOptionalText("[data-fe-task-bio]", isFollow ? state.task.biography || copy.noBiography : "");
      setOptionalText("[data-fe-task-meta]", isFollow ? profileFollowers(state.task) : String(state.task.targetUrl || "").replace(/^https:\/\/www\.instagram\.com\//, "instagram.com/"));
      if (isFollow) {
        setProfileAvatar(root.querySelector("[data-fe-task-avatar]"), username);
        hydrateProfile(username, state.task.id);
      }
      else {
        var avatar = root.querySelector("[data-fe-task-avatar]");
        var image = avatar.querySelector("[data-fe-avatar-image]");
        var fallback = avatar.querySelector("[data-fe-avatar-fallback]");
        image.hidden = true;
        image.removeAttribute("src");
        fallback.hidden = false;
        fallback.textContent = state.task.type === "like" ? "♥" : "💬";
      }
      var postPreview = root.querySelector("[data-fe-post-preview]");
      var postFrame = root.querySelector("[data-fe-post-frame]");
      var embedUrl = isFollow ? "" : instagramEmbedUrl(state.task.targetUrl);
      postPreview.hidden = !embedUrl;
      if (embedUrl && postFrame.dataset.feSrc !== embedUrl) {
        postFrame.dataset.feSrc = embedUrl;
        postFrame.src = embedUrl;
      } else if (!embedUrl && postFrame.dataset.feSrc) {
        postFrame.dataset.feSrc = "";
        postFrame.removeAttribute("src");
      }
      if (state.task.status !== "completed") state.task.reward = effectiveReward(state.task);
      root.querySelector("[data-fe-reward]").textContent = "🚀 +" + format(state.task.reward || state.reward);

      var action = buttonState();
      var button = root.querySelector("[data-fe-task-button]");
      button.hidden = !action.action;
      button.textContent = action.label;
      button.dataset.action = action.action;
      var directLaunchUrl = action.action === "open"
        ? instagramLaunchUrl(state.task.profileUrl || state.task.targetUrl)
        : "";
      button.setAttribute("href", directLaunchUrl || "#");
      var returnedFromInstagram = state.interaction && (
        state.interaction.pageHidden === true || state.interaction.focusReturned === true || state.interaction.sawBlur === true
        || state.interaction.launchAttempted === true
      );
      var actionDisabled = state.busy || !action.action || (action.action === "complete" && !returnedFromInstagram);
      button.setAttribute("aria-disabled", actionDisabled ? "true" : "false");
      if (action.action === "complete" && !returnedFromInstagram && !state.busy) setMessage(copy.returnPrompt, "");
      var skip = root.querySelector("[data-fe-task-skip]");
      skip.hidden = state.task.status !== "assigned";
      skip.disabled = state.busy;
      var privateReport = root.querySelector("[data-fe-task-private]");
      privateReport.hidden = action.action !== "complete";
      privateReport.textContent = isFollow ? copy.privateAccount : copy.postUnavailable;
      privateReport.disabled = state.busy;
      root.querySelector("[data-fe-task-actions]").classList.toggle("is-single", skip.hidden && privateReport.hidden);
      root.querySelector("[data-fe-verification-note]").hidden = action.action !== "complete";
    }

    function animateReward(amount) {
      if (!amount || amount < 1) return;
      var balance = root.querySelector(".fe-balance");
      var rect = balance.getBoundingClientRect();
      var node = document.createElement("span");
      node.className = "fe-reward-fly";
      node.textContent = "🚀 +" + format(amount);
      node.style.left = rect.left + rect.width / 2 + "px";
      node.style.top = rect.top + "px";
      document.body.appendChild(node);
      window.setTimeout(function () { node.remove(); }, 1000);
    }

    function loadState(options) {
      var settings = options && typeof options === "object" ? options : {};
      if (state.loadingState) return state.loadingState;
      clearEmptyTaskState();
      setBusy(true);
      root.querySelector("[data-fe-loading]").hidden = false;
      if (!settings.preserveMessage) setMessage("", "");
      var referralCode = "";
      try { referralCode = new URLSearchParams(window.location.search).get("ref") || ""; } catch {}
      state.loadingState = request("state", {
        referralCode: referralCode,
        tokenCandidates: readSessionTokenCandidates()
      }).then(function (body) {
        try {
          var savedNotice = JSON.parse(readStorage(FAILURE_NOTICE_KEY) || "null");
          if (savedNotice && savedNotice.locked === true) {
            writeStorage(FAILURE_NOTICE_KEY, "");
            hideTaskNotice(root.querySelector("[data-fe-failure-notice]"));
            state.paused = false;
          }
        } catch {}
        saveSession(body);
        saveMissionState(body);
        state.tasks = body.tasks && typeof body.tasks === "object" ? {
          follow: Array.isArray(body.tasks.follow) ? body.tasks.follow : [],
          like: Array.isArray(body.tasks.like) ? body.tasks.like : []
        } : { follow: Array.isArray(body.profiles) ? body.profiles : [], like: [] };
        if (restoreServerTask(body.activeTask)) return;
        return reserveNextTask(String(settings.excludeKey || ""));
      }).catch(function (error) {
        state.task = null;
        state.stockExhausted = true;
        if (error && error.code === "task_suspended") {
          state.paused = true;
          showFailureNotice(error.message || copy.genericError, true);
        } else {
          setMessage(error.message || copy.genericError, "error");
        }
      }).finally(function () {
        state.loadingState = null;
        setBusy(false);
        renderTask();
      });
      return state.loadingState;
    }

    function rememberSkipped(key) {
      if (!key) return;
      var skipped = readSkipped().filter(function (id) { return id !== key; });
      skipped.push(key);
      writeStorage(SKIP_KEY, JSON.stringify(skipped.slice(-80)));
    }

    function releaseCurrentTask(reason, reserveAfter) {
      if (!state.task || !state.interaction || state.interaction.status !== "assigned") return Promise.resolve();
      var interaction = state.interaction;
      var key = taskKey(state.task);
      clearReservationTimer();
      rememberSkipped(key);
      state.task = null;
      state.interaction = null;
      writeStorage(OPEN_KEY, "");
      renderTask();
      return request("release", { attemptId: interaction.attemptId, reason: reason || "skipped" })
        .catch(function () {})
        .then(function () {
          if (reserveAfter === false) return undefined;
          return reserveNextTask(key, true).then(function () {
            if (!state.task) return loadState({ preserveMessage: true, excludeKey: key });
          });
        });
    }

    function skipCurrent() {
      if (!state.task || state.task.status !== "assigned") return;
      setMessage("", "");
      if (!state.interaction) {
        var skippedTask = state.task;
        var key = taskKey(skippedTask);
        rememberSkipped(key);
        state.tasks[skippedTask.type] = (state.tasks[skippedTask.type] || []).filter(function (candidate) {
          return String(candidate.id) !== String(skippedTask.id);
        });
        state.task = null;
        clearReservationTimer();
        renderTask();
        reserveNextTask(key, true).then(function () {
          if (!state.task) return loadState({ preserveMessage: true, excludeKey: key });
        });
        return;
      }
      releaseCurrentTask("skipped");
    }

    function pollOpenBaseline(interaction) {
      if (!interaction || !interaction.baselineVerificationJob || state.pendingTimers["open:" + interaction.attemptId]) return;
      var timerKey = "open:" + interaction.attemptId;
      var retryAfter = Math.max(1500, Math.min(10000, Number(interaction.retryAfterMs || 3000)));
      state.pendingTimers[timerKey] = window.setTimeout(function run() {
        delete state.pendingTimers[timerKey];
        if (!state.interaction || String(state.interaction.attemptId) !== String(interaction.attemptId)) return;
        request("open", {
          taskType: interaction.taskType,
          targetId: interaction.targetId,
          attemptId: interaction.attemptId,
          verificationJob: interaction.baselineVerificationJob
        }).then(function (body) {
          saveSession(body);
          if (!state.interaction || String(state.interaction.attemptId) !== String(interaction.attemptId)) return;
          if (body.verificationPending) {
            state.interaction.baselineVerificationJob = String(body.verificationJob || interaction.baselineVerificationJob);
            state.interaction.retryAfterMs = Number(body.retryAfterMs || 3000);
            writeStorage(OPEN_KEY, JSON.stringify(state.interaction));
            pollOpenBaseline(state.interaction);
            return;
          }
          if (body.profile && state.task) {
            updateFollowTaskProfile(body);
          }
          if (state.interaction.baselineMode === "prefetch") {
            markFollowBaselineReady(body, state.interaction);
            return;
          }
          delete state.interaction.pendingLaunchUrl;
          delete state.interaction.baselineVerificationJob;
          delete state.interaction.retryAfterMs;
          setMessage("", "");
          finishOpen(body, state.interaction);
        }).catch(function (error) {
          if (!state.interaction || String(state.interaction.attemptId) !== String(interaction.attemptId)) return;
          if (state.interaction.baselineMode === "prefetch") {
            discardPreparedTask(state.interaction, error);
            return;
          }
          state.interaction.baselineFailed = true;
          delete state.interaction.baselineVerificationJob;
          delete state.interaction.retryAfterMs;
          writeStorage(OPEN_KEY, JSON.stringify(state.interaction));
          setMessage(error.message || copy.genericError, "error");
        });
      }, retryAfter);
    }

    function finishOpen(body, interaction) {
      saveSession(body);
      if (body.profile && state.task && state.task.type === "follow") {
        state.task.displayName = body.profile.displayName || state.task.displayName;
        state.task.biography = body.profile.biography || "";
        state.task.followersCount = body.profile.followersCount != null ? Number(body.profile.followersCount) : null;
      }
      interaction.status = "opened";
      interaction.launchAttempted = true;
      interaction.openedAt = Date.now();
      interaction.expiresAt = new Date(String(body.expiresAt || "")).getTime() || Date.now() + 15 * 60 * 1000;
      state.interaction = interaction;
      if (state.task) state.task.status = "opened";
      writeStorage(OPEN_KEY, JSON.stringify(interaction));
      renderTask();
    }

    function openTask() {
      if (!state.task || state.task.status !== "assigned") return;
      clearReservationTimer();
      var previewTask = Object.assign({}, state.task);
      var targetUrl = instagramUniversalUrl(state.task.profileUrl || state.task.targetUrl);
      if (!targetUrl) {
        setMessage(copy.genericError, "error");
        return;
      }
      var hadReservation = Boolean(state.interaction && state.interaction.attemptId);
      var interaction = state.interaction || {
        attemptId: "",
        targetId: String(state.task.id),
        taskType: String(state.task.type),
        status: "assigned",
        openedAt: 0,
        expiresAt: Date.now() + 15 * 60 * 1000,
        reward: Number(state.task.reward || state.task.baseReward || baseRewardForType(state.task.type)),
        missionCode: String(state.task.missionCode || ""),
        baselineReady: false
      };
      interaction.pageHidden = false;
      interaction.sawBlur = false;
      interaction.focusReturned = false;
      interaction.launchAttempted = false;
      interaction.pendingLaunchUrl = targetUrl;
      if (!interaction.tiktokEventId) interaction.tiktokEventId = newTikTokEventId();
      if (interaction.tiktokEventTracked !== true) {
        trackTikTokTaskButton(state.task, interaction.tiktokEventId);
        interaction.tiktokEventTracked = true;
      }
      if (interaction.attemptId) writeStorage(OPEN_KEY, JSON.stringify(interaction));
      setMessage(copy.opening, "");
      setBusy(true);
      request("open", {
        taskType: state.task.type,
        targetId: state.task.id,
        attemptId: interaction.attemptId || undefined,
        tiktok: readTikTokAttribution(interaction.tiktokEventId)
      }, { keepalive: true }).then(function (body) {
        interaction.attemptId = String(body.attemptId || interaction.attemptId || "");
        interaction.baselineReady = body.baselineReady === true;
        interaction.openedAt = Date.now();
        interaction.expiresAt = new Date(String(body.expiresAt || "")).getTime() || Date.now() + 15 * 60 * 1000;
        interaction.pageHidden = document.visibilityState === "hidden";
        interaction.sawBlur = !document.hasFocus();
        interaction.focusReturned = false;
        if (body.verificationPending) {
          interaction.status = "preparing";
          interaction.baselineVerificationJob = String(body.verificationJob || "");
          interaction.retryAfterMs = Number(body.retryAfterMs || 3000);
          state.interaction = interaction;
          state.task.status = "preparing";
          writeStorage(OPEN_KEY, JSON.stringify(interaction));
          setMessage(copy.opening, "");
          renderTask();
          pollOpenBaseline(interaction);
        } else {
          delete interaction.pendingLaunchUrl;
          recordTaskRotation(previewTask);
          finishOpen(body, interaction);
        }
        setBusy(false);
        renderTask();
      }).catch(function (error) {
        delete interaction.pendingLaunchUrl;
        if (!hadReservation && RETRYABLE_RESERVATION_CODES.indexOf(String(error && error.code || "")) >= 0) {
          var key = taskKey(previewTask);
          state.unavailableTaskKeys.add(key);
          state.tasks[previewTask.type] = (state.tasks[previewTask.type] || []).filter(function (candidate) {
            return String(candidate.id) !== String(previewTask.id);
          });
          state.task = null;
          state.interaction = null;
          writeStorage(OPEN_KEY, "");
          reserveNextTask(key, true).then(function () {
            if (!state.task) return loadState({ preserveMessage: true, excludeKey: key });
          });
        } else {
          interaction.status = "assigned";
          interaction.launchAttempted = false;
          if (state.task) state.task.status = "assigned";
          state.interaction = hadReservation ? interaction : null;
          writeStorage(OPEN_KEY, hadReservation ? JSON.stringify(interaction) : "");
          scheduleReservationExpiry();
        }
        setBusy(false);
        setMessage(error.message || copy.genericError, "error");
        renderTask();
      });
    }

    function removePendingAttempt(attemptId) {
      state.pending = state.pending.filter(function (item) { return String(item.attemptId) !== String(attemptId); });
      writeStorage(PENDING_KEY, state.pending.length ? JSON.stringify(state.pending) : "");
      var timerKey = "claim:" + String(attemptId);
      if (state.pendingTimers[timerKey]) window.clearTimeout(state.pendingTimers[timerKey]);
      delete state.pendingTimers[timerKey];
    }

    function showTaskNotice(notice) {
      if (!notice) return;
      var card = notice.closest(".fe-task-card");
      var notices = card ? card.querySelectorAll("[data-fe-task-notice]") : [];
      Array.prototype.forEach.call(notices, function (item) { item.hidden = item !== notice; });
      notice.hidden = false;
      if (card) card.classList.add("has-task-notice");
      var button = notice.querySelector("button");
      if (button && !button.hidden) window.requestAnimationFrame(function () { button.focus({ preventScroll: true }); });
    }

    function hideTaskNotice(notice) {
      if (!notice) return;
      notice.hidden = true;
      var card = notice.closest(".fe-task-card");
      if (card && !card.querySelector("[data-fe-task-notice]:not([hidden])")) card.classList.remove("has-task-notice");
    }

    function showFailureNotice(message, locked) {
      var notice = root.querySelector("[data-fe-failure-notice]");
      var text = root.querySelector("[data-fe-failure-message]");
      var dismiss = root.querySelector("[data-fe-understood]");
      var safeMessage = String(message || copy.failureText || "").slice(0, 500);
      var policyWarning = String(copy.rewardPolicyWarning || "").trim();
      if (!locked && policyWarning && safeMessage.indexOf(policyWarning) === -1) {
        safeMessage = (safeMessage + " " + policyWarning).trim().slice(0, 500);
      }
      if (text) text.textContent = safeMessage;
      if (dismiss) dismiss.hidden = locked === true;
      writeStorage(FAILURE_NOTICE_KEY, JSON.stringify({ message: safeMessage, locked: locked === true }));
      showTaskNotice(notice);
    }

    function refreshBalanceAfterFailedVerification(message) {
      var suspensionMessage = "";
      return request("state", {}).then(function (body) {
        saveSession(body);
        saveMissionState(body);
        renderTask();
      }).catch(function (error) {
        if (error && error.code === "task_suspended") {
          state.paused = true;
          suspensionMessage = error.message || copy.genericError;
        }
      }).finally(function () {
        showFailureNotice(suspensionMessage || message || copy.failureText, Boolean(suspensionMessage));
      });
    }

    function restoreFailureNotice() {
      try {
        var saved = JSON.parse(readStorage(FAILURE_NOTICE_KEY) || "null");
        if (saved && typeof saved === "object" && typeof saved.message === "string" && saved.message) {
          showFailureNotice(saved.message, saved.locked === true);
        }
      } catch {
        writeStorage(FAILURE_NOTICE_KEY, "");
      }
    }

    function pollPendingClaim(item) {
      var timerKey = "claim:" + String(item.attemptId);
      if (state.pendingTimers[timerKey]) return;
      if (!Number(item.startedAt || 0)) {
        item.startedAt = Date.now();
        savePending();
      }
      if (Date.now() - Number(item.startedAt) >= PENDING_MAX_AGE_MS) {
        removePendingAttempt(item.attemptId);
        rememberSkipped(String(item.taskType) + ":" + String(item.targetId));
        refreshBalanceAfterFailedVerification(copy.genericError);
        return;
      }
      var retryAfter = item.verificationJob || item.baselineVerificationJob
        ? Math.max(1500, Math.min(10000, Number(item.retryAfterMs || 3000)))
        : 50;
      state.pendingTimers[timerKey] = window.setTimeout(function () {
        delete state.pendingTimers[timerKey];
        var current = state.pending.find(function (entry) { return String(entry.attemptId) === String(item.attemptId); });
        if (!current) return;
        if (current.baselineVerificationJob) {
          request("open", {
            taskType: current.taskType,
            targetId: current.targetId,
            attemptId: current.attemptId,
            verificationJob: current.baselineVerificationJob
          }).then(function (body) {
            saveSession(body);
            if (body.verificationPending) {
              current.baselineVerificationJob = String(body.verificationJob || current.baselineVerificationJob);
              current.retryAfterMs = Number(body.retryAfterMs || 3000);
            } else {
              current.baselineVerificationJob = "";
              current.retryAfterMs = 50;
            }
            savePending();
            pollPendingClaim(current);
          }).catch(function (error) {
            if ((!error || !error.status || error.status === 429 || error.status >= 500) && Date.now() - Number(current.startedAt || Date.now()) < PENDING_MAX_AGE_MS) {
              current.retryAfterMs = Math.min(10000, Math.max(3000, Number(current.retryAfterMs || 3000) * 1.5));
              savePending();
              pollPendingClaim(current);
              return;
            }
            removePendingAttempt(current.attemptId);
            rememberSkipped(String(current.taskType) + ":" + String(current.targetId));
            refreshBalanceAfterFailedVerification(error.message || copy.failureText);
          });
          return;
        }
        request("claim", {
          attemptId: current.attemptId,
          elapsedMs: current.elapsedMs,
          pageHidden: current.pageHidden === true,
          focusReturned: current.focusReturned === true,
          verificationJob: current.verificationJob
        }).then(function (body) {
          var balanceBeforeApply = state.balance;
          saveSession(body);
          state.balance = Math.max(balanceBeforeApply, state.balance);
          saveMissionState(body);
          if (body.verificationPending) {
            current.verificationJob = String(body.verificationJob || current.verificationJob);
            current.retryAfterMs = Number(body.retryAfterMs || 3000);
            writeStorage(PENDING_KEY, JSON.stringify(state.pending));
            pollPendingClaim(current);
            return;
          }
          removePendingAttempt(current.attemptId);
          animateReward(Math.max(0, state.balance - balanceBeforeApply));
          renderTask();
        }).catch(function (error) {
          if ((!error || !error.status || error.status === 429 || error.status >= 500) && Date.now() - Number(current.startedAt || Date.now()) < PENDING_MAX_AGE_MS) {
            current.retryAfterMs = Math.min(10000, Math.max(3000, Number(current.retryAfterMs || 3000) * 1.5));
            savePending();
            pollPendingClaim(current);
            return;
          }
          removePendingAttempt(current.attemptId);
          rememberSkipped(String(current.taskType) + ":" + String(current.targetId));
          refreshBalanceAfterFailedVerification(error.message || copy.failureText);
        });
      }, retryAfter);
    }

    function resumePendingClaims() {
      state.pending.slice().forEach(pollPendingClaim);
    }

    function advanceAfterSubmission(task, message) {
      var key = taskKey(task);
      state.tasks[task.type] = (state.tasks[task.type] || []).filter(function (candidate) {
        return String(candidate.id) !== String(task.id);
      });
      state.task = null;
      state.interaction = null;
      writeStorage(OPEN_KEY, "");
      setMessage(message || "", "");
      renderTask();
      return reserveNextTask(key, true).then(function () {
        if (!state.task) return loadState({ preserveMessage: true, excludeKey: key });
      });
    }

    function completeTask() {
      if (!state.task || state.task.status !== "opened") return;
      var completedTask = Object.assign({}, state.task);
      var interaction = state.interaction || readOpenAttempt();
      if (!interaction || !interaction.attemptId) {
        state.task.status = "assigned";
        writeStorage(OPEN_KEY, "");
        setMessage(copy.genericError, "error");
        renderTask();
        return;
      }
      setBusy(true);
      setMessage(copy.verifying, "");
      var balanceBeforeProvisionalReward = state.balance;
      request("pending", {
        attemptId: interaction.attemptId,
        elapsedMs: Math.max(0, Date.now() - Number(interaction.openedAt || Date.now())),
        pageHidden: interaction.pageHidden === true,
        focusReturned: interaction.focusReturned === true || interaction.sawBlur === true
      }).then(function (body) {
        saveSession(body);
        animateReward(Math.max(0, state.balance - balanceBeforeProvisionalReward));
        var pending = {
          attemptId: String(interaction.attemptId),
          targetId: String(interaction.targetId),
          taskType: String(interaction.taskType),
          verificationJob: "",
          baselineVerificationJob: String(interaction.baselineVerificationJob || ""),
          retryAfterMs: 50,
          startedAt: Date.now(),
          elapsedMs: Math.max(0, Date.now() - Number(interaction.openedAt || Date.now())),
          pageHidden: interaction.pageHidden === true,
          focusReturned: interaction.focusReturned === true || interaction.sawBlur === true
        };
        state.pending.push(pending);
        savePending();
        pollPendingClaim(pending);
        return advanceAfterSubmission(completedTask, copy.pendingMessage);
      }).catch(function (error) {
        setMessage(error.message || copy.genericError, "error");
      }).finally(function () {
        setBusy(false);
        renderTask();
      });
    }

    function reportPrivateTask() {
      if (!state.task || state.task.status !== "opened") return;
      var reportedTask = Object.assign({}, state.task);
      var interaction = state.interaction || readOpenAttempt();
      if (!interaction || !interaction.attemptId) {
        setMessage(copy.genericError, "error");
        return;
      }
      setBusy(true);
      setMessage(reportedTask.type === "follow" ? copy.reportingPrivate : copy.reportingPost, "");
      request("report_private", { attemptId: interaction.attemptId }).then(function (body) {
        saveSession(body);
        rememberSkipped(taskKey(reportedTask));
        return advanceAfterSubmission(reportedTask, reportedTask.type === "follow" ? copy.privateReported : copy.postReported);
      }).catch(function (error) {
        setMessage(error.message || copy.genericError, "error");
      }).finally(function () {
        setBusy(false);
        renderTask();
      });
    }

    function invitationUrl(code) {
      var url = new URL("/pages/bine-ai-venit", window.location.origin);
      url.searchParams.set("view", "urmareste");
      url.searchParams.set("ref", String(code || ""));
      return url.toString();
    }

    function legacyCopyText(value) {
      var field = document.createElement("textarea");
      var copied = false;
      field.value = String(value || "");
      field.setAttribute("readonly", "");
      field.setAttribute("aria-hidden", "true");
      field.style.position = "fixed";
      field.style.top = "-9999px";
      field.style.left = "-9999px";
      field.style.opacity = "0";
      document.body.appendChild(field);
      field.focus();
      field.select();
      field.setSelectionRange(0, field.value.length);
      try { copied = document.execCommand("copy"); } catch {}
      field.remove();
      return copied;
    }

    function copyText(value) {
      var text = String(value || "");
      if (!text) return Promise.resolve(false);
      if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
        return navigator.clipboard.writeText(text)
          .then(function () { return true; })
          .catch(function () { return legacyCopyText(text); });
      }
      return Promise.resolve(legacyCopyText(text));
    }

    function startMission(code) {
      setBusy(true);
      setMissionMessage("", "");
      request("start_mission", { missionCode: code }).then(function (body) {
        saveSession(body);
        saveMissionState(body);
        if (code === "invite_five") {
          var referralCode = String(body.referralCode || state.referralCode || "");
          if (!referralCode) throw new Error(copy.genericError);
          state.referralCode = referralCode;
          var link = invitationUrl(referralCode);
          return copyText(link).then(function (copied) {
            setMissionMessage(copied ? copy.inviteCopied : copy.missionShared + " " + link, "success");
          });
        }
        setMissionMessage(code === "double_rockets" ? copy.boostActive : copy.missionStarted, "success");
        if (code === "double_rockets") return loadState();
      }).catch(function (error) {
        setMissionMessage(error.message || copy.genericError, "error");
      }).finally(function () {
        setBusy(false);
        renderTask();
      });
    }

    function buyPaidBoost() {
      if (!paidBoostVariantId) {
        setMissionMessage(copy.genericError, "error");
        return;
      }
      setBusy(true);
      setMissionMessage("", "");
      request("boost_checkout", {}).then(function (body) {
        saveSession(body);
        if (!body.purchaseToken) throw new Error(copy.genericError);
        return fetchWithTimeout("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({
            items: [{
              id: paidBoostVariantId,
              quantity: 1,
              properties: { _FaimaBoostPurchase: String(body.purchaseToken) }
            }]
          })
        }, REQUEST_TIMEOUT_MS);
      }).then(function (response) {
        if (!response.ok) throw new Error(copy.genericError);
        window.location.assign("/checkout");
      }).catch(function (error) {
        setMissionMessage(error.message || copy.genericError, "error");
        setBusy(false);
        renderTask();
      });
    }

    function copySessionCode() {
      if (!state.token) {
        setMessage(copy.genericError, "error");
        return;
      }
      copyText(state.token).then(function (copied) {
        if (!copied) {
          setMessage(copy.genericError, "error");
          return;
        }
        var label = root.querySelector("[data-fe-copy-code-label]");
        var card = root.querySelector("[data-fe-copy-code]");
        var icon = root.querySelector("[data-fe-copy-code-icon]");
        if (label) label.textContent = copy.codeCopied;
        if (card) card.classList.add("is-copied");
        if (icon) icon.textContent = "✓";
        window.setTimeout(function () {
          if (label) label.textContent = copy.copyCode;
          if (card) card.classList.remove("is-copied");
          if (icon) icon.textContent = "⧉";
        }, 2200);
      });
    }

    function openRestoreDialog() {
      var dialog = root.querySelector("[data-fe-restore-dialog]");
      if (!dialog) return;
      if (typeof dialog.showModal === "function" && !dialog.open) dialog.showModal();
      else dialog.setAttribute("open", "");
    }

    function closeDialog(dialog) {
      if (!dialog) return;
      if (typeof dialog.close === "function") dialog.close();
      else dialog.removeAttribute("open");
    }

    function restoreBalance() {
      var dialog = root.querySelector("[data-fe-restore-dialog]");
      var input = root.querySelector("[data-fe-restore-input]");
      var message = root.querySelector("[data-fe-restore-message]");
      var code = input ? String(input.value || "").trim() : "";
      if (message) {
        message.textContent = "";
        message.classList.remove("is-error", "is-success");
      }
      request("restore", { code: code }).then(function (body) {
        saveSession(body);
        state.pending = [];
        writeStorage(PENDING_KEY, "");
        clearReservationTimer();
        state.task = null;
        state.interaction = null;
        writeStorage(OPEN_KEY, "");
        if (message) {
          message.textContent = copy.restoreSuccess;
          message.classList.add("is-success");
        }
        window.setTimeout(function () {
          closeDialog(dialog);
          loadState();
        }, 650);
      }).catch(function (error) {
        if (message) {
          message.textContent = error.message || copy.genericError;
          message.classList.add("is-error");
        }
      });
    }

    root.addEventListener("click", function (event) {
      if (event.target.closest("[data-fe-buy-boost]")) { buyPaidBoost(); return; }
      var missionButton = event.target.closest("[data-fe-mission-button]");
      if (missionButton) {
        startMission(String(missionButton.dataset.feMissionButton || ""));
        return;
      }
      if (event.target.closest("[data-fe-copy-code]")) { copySessionCode(); return; }
      if (event.target.closest("[data-fe-open-restore]")) { openRestoreDialog(); return; }
      if (event.target.closest("[data-fe-restore-submit]")) { restoreBalance(); return; }
      if (event.target.closest("[data-fe-restore-cancel]")) {
        closeDialog(root.querySelector("[data-fe-restore-dialog]"));
        return;
      }
      if (event.target.closest("[data-fe-understood]")) {
        writeStorage(FAILURE_NOTICE_KEY, "");
        hideTaskNotice(root.querySelector("[data-fe-failure-notice]"));
        return;
      }
      if (event.target.closest("[data-fe-task-private]")) { reportPrivateTask(); return; }
      var skip = event.target.closest("[data-fe-task-skip]");
      if (skip) { skipCurrent(); return; }
      var button = event.target.closest("[data-fe-task-button]");
      if (!button) return;
      if (button.getAttribute("aria-disabled") === "true") {
        event.preventDefault();
        return;
      }
      if (button.dataset.action === "open") {
        openTask();
        return;
      }
      event.preventDefault();
      if (button.dataset.action === "complete") completeTask();
      else if (button.dataset.action) loadState();
    });

    document.addEventListener("visibilitychange", function () {
      if (!state.interaction) return;
      if (document.visibilityState === "hidden") state.interaction.pageHidden = true;
      else if (state.interaction.pageHidden || state.interaction.sawBlur) state.interaction.focusReturned = true;
      writeStorage(OPEN_KEY, JSON.stringify(state.interaction));
      if (document.visibilityState === "visible") {
        setMessage("", "");
        renderTask();
      }
    });
    window.addEventListener("blur", function () {
      if (!state.interaction) return;
      state.interaction.sawBlur = true;
      writeStorage(OPEN_KEY, JSON.stringify(state.interaction));
    });
    window.addEventListener("pagehide", function () {
      if (!state.interaction) return;
      state.interaction.pageHidden = true;
      writeStorage(OPEN_KEY, JSON.stringify(state.interaction));
    });
    window.addEventListener("pageshow", function () {
      if (!state.interaction && state.task && state.task.status === "assigned") {
        loadState({ preserveMessage: true });
        return;
      }
      if (!state.interaction || !state.interaction.pageHidden) return;
      state.interaction.focusReturned = true;
      writeStorage(OPEN_KEY, JSON.stringify(state.interaction));
      setMessage("", "");
      renderTask();
    });
    window.addEventListener("focus", function () {
      if (!state.interaction || !state.interaction.sawBlur) return;
      state.interaction.focusReturned = true;
      writeStorage(OPEN_KEY, JSON.stringify(state.interaction));
      setMessage("", "");
      renderTask();
    });

    renderTask();
    loadState();
    resumePendingClaims();
    restoreFailureNotice();
    window.setInterval(function () {
      if (state.boost && secondsUntil(state.boost.expiresAt) < 1) {
        state.boost = null;
        loadState({ preserveMessage: true });
        return;
      }
      renderTask();
    }, 1000);
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll("[data-fe-root]").forEach(initialize);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initializeAll(document); });
  else initializeAll(document);
  document.addEventListener("shopify:section:load", function (event) { initializeAll(event.target); });
})();
